import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { cn } from '@/lib/cn';

type Theme = 'light' | 'dark';

function current(): Theme {
  if (typeof document === 'undefined') return 'light';
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}

export function ThemeToggle({ className }: { className?: string }) {
  const [theme, setTheme] = useState<Theme>(current);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    try {
      localStorage.setItem('theme', theme);
    } catch {
      /* storage unavailable — fine, just don't persist */
    }
  }, [theme]);

  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={`Switch to ${next} theme`}
      className={cn(
        'inline-flex size-9 items-center justify-center rounded-full text-ink-soft',
        'transition-colors hover:bg-surface-sunken hover:text-ink',
        className,
      )}
    >
      {theme === 'dark' ? (
        <Sun className="size-[1.05rem]" strokeWidth={1.75} />
      ) : (
        <Moon className="size-[1.05rem]" strokeWidth={1.75} />
      )}
    </button>
  );
}
